<app-auth-shell>
  <div class="af-head">
    <h1>Welcome back</h1>
    <p>Sign in to continue your adventure.</p>
  </div>

  @if (notice) {
    <div class="af-alert af-alert--info" role="status"><p>{{ notice }}</p></div>
  }

  @if (error) {
    <div class="af-alert af-alert--error" role="alert">
      <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5M12 16.5v.01"/></svg>
      <p>
        {{ error.message }}
        @if (error.code === 'email_not_verified') {
          <button type="button" class="af-alert-action" (click)="resendLink()" [disabled]="resendState !== 'idle'">
            {{ resendState === 'sending' ? 'Sending…' : 'Send the link again' }}
          </button>
        }
        @if (error.code === 'invalid_credentials') {
          <a class="af-alert-action" routerLink="/forgot-password" [queryParams]="{ email: form.controls.email.value }">Forgot your password?</a>
        }
      </p>
    </div>
  }

  <form class="af-form" [formGroup]="form" (ngSubmit)="submit()" novalidate>
    <div class="af-field">
      <label class="af-label" for="login-email">Email</label>
      <input
        id="login-email"
        class="af-input"
        type="email"
        formControlName="email"
        autocomplete="username"
        inputmode="email"
        autocapitalize="off"
        spellcheck="false"
        [class.is-invalid]="emailInvalid"
        [attr.aria-invalid]="emailInvalid"
        autofocus
      />
      @if (emailInvalid) {
        <p class="af-error">Enter a valid email address.</p>
      }
    </div>

    <div class="af-field">
      <app-password-field
        [control]="form.controls.password"
        inputId="login-password"
        autocomplete="current-password"
      ></app-password-field>
      <div class="af-forgot">
        <a class="af-link af-link--small" routerLink="/forgot-password" [queryParams]="{ email: form.controls.email.value || null }">Forgot password?</a>
      </div>
    </div>

    <button type="submit" class="af-btn af-btn--primary" [disabled]="busy">
      @if (busy) { <span class="af-spinner" aria-hidden="true"></span> Signing in… } @else { Sign in }
    </button>
  </form>

  <p class="af-foot">New to WorldTumbler? <a class="af-link" routerLink="/signup">Create an account</a></p>
</app-auth-shell>
